<template>
  <div class="table-section-header-pagination">
    <div v-if="pagination.index > 0" v-on:click="setIndex(pagination.index - 1)" class="list-page">
      &#60;
    </div>
    <div v-if="pageRange.min > 0" v-on:click="setIndex(0)" class="list-page">
      1
    </div>
    <template v-if="pages <= maxPages">
      <div
        v-for="index in pages"
        v-bind:key="index"
        v-on:click="setIndex(index - 1)"
        class="list-page"
        :class="{ selected: pagination.index + 1 === index }"
      >
        {{ index }}
      </div>
    </template>
    <template v-else>
      <div v-if="pageRange.min > 0">...</div>
      <div
        v-for="i in (pageRange.max - pageRange.min + 1)"
        v-bind:key="i"
        v-on:click="setIndex(i - 1 + pageRange.min)"
        class="list-page"
        :class="{ selected: pagination.index + 1 === i + pageRange.min }"
      >
        {{ i + pageRange.min }}
      </div>
      <div v-if="pageRange.max < pages - 1">...</div>
    </template>
    <div v-if="pageRange.max < pages - 1" v-on:click="setIndex(pages - 1)" class="list-page">
      {{ pages }}
    </div>
    <div
      v-if="pagination.index < pages - 1"
      v-on:click="setIndex(pagination.index + 1)"
      class="list-page"
      :class="{ selected: pagination.index === pages - 1 }"
    >
      &#62;
    </div>
  </div>
</template>

<script>
import { computed } from "@vue/composition-api";

export default {
  name: "TablePagination",
  props: {
    maxPages: {
      type: Number,
      default: 5,
    },
    pages: Number,
    pagination: Object,
  },
  setup(props, { emit }) {
    const pageRange = computed(() => {
      let offset = props.pagination.index + 1 - Math.ceil(props.maxPages / 2);
      if (offset < 0) {
        offset = 0;
      } else if (offset + props.maxPages > props.pages) {
        offset = props.pages - props.maxPages;
      }
      let min = offset;
      if (min <= 2) min = 0;
      let max = offset + props.maxPages - 1;
      if (max >= props.pages - 3) max = props.pages - 1;
      return { min, max };
    });
    const setIndex = (index) => emit("update:pagination", { index, size: props.pagination.size });

    return {
      pageRange,
      setIndex,
    };
  },
};
</script>

<style lang="scss" scoped>
.table-section-header-pagination {
  display: flex;
  font-size: 0.75rem;
  align-items: center;
  justify-content: flex-end;
  .list-page {
    height: 100%;
    display: flex;
    align-items: center;
    cursor: pointer;
    &.selected {
      font-weight: bold;
      cursor: not-allowed;
      &:hover {
        background: inherit;
      }
    }
    &:hover {
      font-weight: bold;
    }
  }
  div {
    padding: 0 0.4rem;
  }
}
</style>
